// extracted by mini-css-extract-plugin
export var article = "blog-post-module--article--75029";
export var articleNavigation = "blog-post-module--articleNavigation--db4e2";
export var body = "blog-post-module--body--7e623";
export var container = "blog-post-module--container--2348d";
export var meta = "blog-post-module--meta--5f023";